<!-- <button mat-stroked-button matTooltip="Load map" color="primary" (click)="onLoadMap()" ><mat-icon>map</mat-icon></button> -->
<div id="load" class="loader"></div> 

<div id="legend" class="gipmapp-legend" style="display:none;"></div> 

<div id="map" class="gipmapp"></div> 

<div id="status" class="gipmapp-status"></div> 